import {first} from '@shared/helpers/array'

import {SellerExceptionalCategory, DeliveryAttributeCode} from '@web/core/constants'
import {ProductType, Status} from '@web/slices/pickup/slice'
import makeSlice from '@web/slices/pickup/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {branch, products, merchantsByMerchantNo, purchaser, deliveryAddressBook} = payload.data
            const primaryProduct = first(products)
            const primaryMerchant = first(Object.values(merchantsByMerchantNo))
            const primaryBranchName = first(Object.values(branch?.branchNamesByDeliveryGroupKey ?? {}))

            if (!branch || !primaryProduct || !primaryMerchant) {
                return
            }

            if (primaryProduct.deliveryAttributeType !== DeliveryAttributeCode.PICKUP) {
                return
            }

            state.merchantName = primaryMerchant.name
            state.branchName = primaryBranchName
            state.waitTime = primaryProduct.branchDeliveryView?.branchDeliveryPreparationMinutes ?? 0
            state.productType = products.some(
                (product) => product.sellerExceptionalCategoryType === SellerExceptionalCategory.ALCOHOL,
            )
                ? ProductType.ALCOHOL
                : ProductType.NORMAL
            state.status = Status.REQUEST
            state.location = {
                address: branch.branchAddressView?.baseAddress ?? '',
                subAddress: branch.branchAddressView?.detailAddress ?? '',
                point: {
                    x: branch.branchAddressView?.locationX ?? '',
                    y: branch.branchAddressView?.locationY ?? '',
                },
                imageUrl: primaryMerchant.merchantImageUrl ?? '',
                markerColor: branch.branchAddressView?.markerColor ?? state.location.markerColor,
            }
            state.receiver = {
                name: purchaser.name ?? '',
                phoneNumber: purchaser.phoneNumber ?? '',
                supportVirtualNumber: deliveryAddressBook?.onVirtualPhoneNumber ?? false,
            }
        })
    },
})

export default slice.reducer
